import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-feetscare-list-item';

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">Designed for everyday comfort</h2>
    <p style="text-align: center">
      Feel the weight of the day melt away as your feet embrace soothing relief and rejuvenation. Rediscover the joy of
      unwinding at home, ready to engage with your family and reclaim the peace you deserve.
    </p>
  </div>
  <div
    class="list-item"
    data-attribute="list-item"
    data-bg-item="#ffffff"
    data-color-item="#000000"
    style="--bg-item: #ffffff; --color-item: #000000"
  >
    <div data-attribute="item" class="item-feetscare">
      <h3 style="text-align: center">Ultimate comfort for tired feet</h3>
    </div>
    <div data-attribute="item" class="item-feetscare">
      <h3 style="text-align: center">Luxurious self-care at home</h3>
    </div>
    <div data-attribute="item" class="item-feetscare">
      <h3 style="text-align: center">Easy to use and maintain</h3>
      </p>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#dc9376',
  textColor: '#FFFFFF',
});
